import { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputMask } from "primereact/inputmask";
import { changeStatusProrrogacao, updateItemProrrogacao } from "../../../../../service/Rag/Exercicio";

const ItensProrrogacao = ({
  exercicio,
  acoesList,
  indicadoresList,
  programaSelected,
  programasList,
  cronograma,
  prorrogacoesList,
  setAtualizaList,
}) => {
  const [dynamicColumns, setDynamicColumns] = useState([]);

  const actionTemplate = (node, rowData) => {
    if (node.descStatProrrogacao === "Inativo") {
      return (
        <Button
          type="button"
          className="p-button-warning"
          label="Inativa"
          onClick={() => {
            updateStatusProrrogacao(node);
          }}
        />
      );
    }

    return (
      <Button
        type="button"
        className="p-button-success p-button p-component"
        label="Ativa"
        onClick={() => {
          updateStatusProrrogacao(node);
        }}
      />
    );
  };
  const rowEdit = (node, rowData) => {
    let editar;

    editar = (
      <Button
        type="button"
        className="p-row-editor-init p-link"

        // onClick={() => editExercicio(node)}
      >
        <span className="p-row-editor-init-icon pi pi-fw pi-pencil"></span>
      </Button>
    );

    return <div>{editar}</div>;
  };

  const startDataTable = () => {
    let columns = [];
    if (cronograma.tipoItemRag === "A") {
      columns = [
        { field: "situation", body: actionTemplate, header: "Situação" },
        { field: "rowEdit", body: rowEdit, rowEditor: "rowEditor " },
        { field: "idenProrrogacao", header: "#" },
        { field: "anoExercicio", header: "Exercício" },
        { field: "descUo", header: "UO Resp" },
        { field: "descPrograma", header: "Programa" },
        { field: "descAcao", header: "Ação" },
        { field: "dataInicial", header: "Início" },
        { field: "dataFinal", header: "Fim" },
      ];
    }
    if (cronograma.tipoItemRag === "P") {
      columns = [
        { field: "situation", body: actionTemplate, header: "Situação" },
        { field: "rowEdit", body: rowEdit, rowEditor: "rowEditor " },

        { field: "idenProrrogacao", header: "#" },
        { field: "anoExercicio", header: "Exercício" },
        { field: "descUo", header: "UO Resp" },
        { field: "descPrograma", header: "Programa" },
        { field: "dataInicial", header: "Início" },
        { field: "dataFinal", header: "Fim" },
      ];
    }
    if (cronograma.tipoItemRag === "I") {
      columns = [
        { field: "situation", body: actionTemplate, header: "Situação" },
        { field: "rowEdit", body: rowEdit, rowEditor: "rowEditor " },

        { field: "idenProrrogacao", header: "#" },
        { field: "anoExercicio", header: "Exercício" },
        { field: "descUo", header: "UO Resp" },
        { field: "descPrograma", header: "Programa" },
        { field: "descObjetivo", header: "Objetivo" },
        { field: "descIndicador", header: "Indicador" },
        { field: "dataInicial", header: "Início" },
        { field: "dataFinal", header: "Fim" },
      ];
    }
    setDynamicColumns(
      columns.map((col, i) => {
        if (col.rowEditor) {
          return <Column rowEditor key={col.field} field={col.field} />;
        }
        if (col.header === "Início" || col.header === "Fim") {
          return (
            <Column header={col.header} editor={(options) => textEditor(options)} key={col.field} field={col.field} />
          );
        }
        return <Column header={col.header} body={col.body} key={col.field} field={col.field} />;
      })
    );
  };
  const textEditor = (options) => {
    return (
      <InputMask
        mask="99/99/9999"
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
      />
    );
  };

  const onRowEditSave = async (event) => {
    let dadosProrrogacao = {
      idenProrrogacao: prorrogacoesList[event.index].idenProrrogacao,
      exercicio: exercicio,
      cronograma: cronograma,
      programa: programaSelected,
      descProrrogacao: "",
      programas: programasList,
      ptaMonitoras: acoesList,
      indicadores: indicadoresList,
      dataInicial: event.newData.dataInicial,
      dataFinal: event.newData.dataFinal,
    };
    if (dadosProrrogacao.dataInicial > dadosProrrogacao.dataFinal) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Data  informada invalida!",
      });
    }

    if (dadosProrrogacao.dataInicial === "" || dadosProrrogacao.dataFinal === "") {
      return window.$toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Data  informada invalida!",
      });
    }

    await updateItemProrrogacao(dadosProrrogacao.idenProrrogacao, dadosProrrogacao).then((_res) => {
      if (_res.status === 200) {
        setAtualizaList(true);
        window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });
      }
    });
  };

  const updateStatusProrrogacao = async (data) => {
    let dadosProrrogacao = {
      idenProrrogacao: data.idenProrrogacao,
      statProrrogacao: data.statProrrogacao,
      tipoItemRag: cronograma.tipoItemRag,
    };
    await changeStatusProrrogacao(dadosProrrogacao).then((_res) => {
      if (_res.status === 200) {
        setAtualizaList(true);
        window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });
      }
    });
  };

  useEffect(() => {
    startDataTable();
  }, []);

  return (
    <DataTable
      emptyMessage="Nenhum registro encontrado"
      header="Itens Prorrogados"
      value={prorrogacoesList}
      showGridlines
      responsiveLayout="scroll"
      editMode="row"
      onRowEditComplete={onRowEditSave}
    >
      {dynamicColumns}
    </DataTable>
  );
};
export default ItensProrrogacao;
